__turbopack_context__.v({
  "kabob_menu_arrow": "_4qPNsG_kabob_menu_arrow",
  "kabob_menu_button": "_4qPNsG_kabob_menu_button",
  "kabob_menu_close_button": "_4qPNsG_kabob_menu_close_button",
  "kabob_menu_content": "_4qPNsG_kabob_menu_content",
  "kabob_menu_content_inner": "_4qPNsG_kabob_menu_content_inner",
});
